import { render, staticRenderFns } from "./CreateSubCategoryModal.vue?vue&type=template&id=d5f46bac&scoped=true&"
import script from "./CreateSubCategoryModal.vue?vue&type=script&lang=js&"
export * from "./CreateSubCategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateSubCategoryModal.vue?vue&type=style&index=0&id=d5f46bac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f46bac",
  null
  
)

export default component.exports